import React, { createContext, useContext, useState } from 'react';
import { ProgressContextProps } from './types/progress-context-props';
import { AppSpinnerAction } from './types/spinner-action';

export const ProgressContext = createContext<ProgressContextProps>(null!);

export function ProgressProvider(props: React.PropsWithChildren<unknown>) {
    const [appSpinnerAction, setAppSpinnerAction] = useState<AppSpinnerAction | null>(null);

    const context = {
        showAppSpinner: (message?: string) => { 
            setAppSpinnerAction({message: message});
        },
        hideAppSpinner: () => {
            setAppSpinnerAction(null);
        },
        appSpinnerAction: appSpinnerAction,
    } as ProgressContextProps;

    return <ProgressContext.Provider value={{ ...context }}>{props.children}</ProgressContext.Provider>;
}

export function useProgress() {
    const context = useContext(ProgressContext);

    if (!context) {
        throw new Error('useProgress must be used within the ProgressProvider');
    }

    return context;
}
